import * as Yup from 'yup';
// add validation to driver form
const phoneRegExp = /^[6-9]\d{9}$/;
const loginFormSchema = Yup.object().shape({
    mobile: Yup.string().required('Mobile Number is required.').matches(phoneRegExp, 'Mobile number is not valid'),
})

export default loginFormSchema;
